import React from 'react';
import { Modal } from '@zurich-base-ui/components.modal';
import FeedbackConfirmationPictogram from 'app/assets/Pictograms/FeedbackConfirmation.svg';
import styles from './FeedbackConfirmation.module.scss';

import {
  getFeedbackConfirmation,
  useAppSelector,
  setFeedbackConfirmation,
  useAppDispatch
} from 'app/redux';

const FeedbackConfirmation: React.FC = () => {
  const dispatch = useAppDispatch();
  const isFeedbackConfirmation: boolean = useAppSelector(
    getFeedbackConfirmation
  );

  return (
    <Modal
      on={isFeedbackConfirmation}
      onClose={() => dispatch(setFeedbackConfirmation(false))}
      variant="slim"
    >
      <div className={`${styles.modal} p-8 pt-6`}>
        <img
          src={FeedbackConfirmationPictogram}
          alt="warning"
          className={styles.pictogram}
        />
        <h2 className="caption-lg-m">Feedback submitted successfully!</h2>
        <p className="caption-lg-r">
          Thank you for taking the time to provide
          <br />
          your valuable feedback.
        </p>
      </div>
    </Modal>
  );
};

export default FeedbackConfirmation;
